
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40.684","height":"38.444","viewBox":"0 0 40.684 38.444"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M0 17.221h9.686v21.224H0zM15.499 0h9.686v38.444h-9.686zM30.999 4.564h9.686v33.88h-9.686z"}})])
          )
        }
      }
    